import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import moment from "moment";
import NewsCategorySelector from "^/Components/ScrivitoExtensions/NewsCategorySelector";
import SectionContentWidget from "../../Widgets/SectionContentWidget/SectionContentWidgetClass";

import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";
import {
  defaultPageProperties,
  defaultPageInitialContent,
} from "../_defaultPageEditingConfig";

Scrivito.provideEditingConfig("NewsPage", {
  title: "News Page",
  thumbnailForContent: (obj) => obj.get("image"),
  attributes: localizeAttrList(
    [
      ...defaultPageProperties,
      ...metadataPropertiesGroup.properties,
      "author",
      "shortDescription",
      "titleImage",
      "tags",
      "video",
      "image",
      "displayOnThisPage",
    ],
    "NewsPage"
  ),
  properties: [
    "title",
    "shortTitle",
    "author",
    "description",
    "shortDescription",
    "publishFromDate",
    "publishUntilDate",
    "image",
    "video",
    "tags",
    "displayOnThisPage",
    "showInGlobalNews",
  ],
  propertiesGroups: [
    {
      title: "Categories",
      key: "categories",
      component: ({ page }) => (
        <NewsCategorySelector
          content={page}
          lang={page.language()}
          currentValues={page.get("customizableCategories")}
          attributeName="customizableCategories"
        />
      ),
    },
    socialCardsPropertiesGroup,
    metadataPropertiesGroup,
  ],
  initialContent: {
    publishFromDate: moment().startOf("day").toDate(),
    publishUntilDate: moment().add(2, "years").endOf("day").toDate(),
    ...metadataInitialContent,
    ...defaultPageInitialContent,
    body: [new SectionContentWidget({})],
    title: "This News Title",
    showInGlobalNews: true,
  },
  validations: [
    [
      "publishFromDate",
      (date, { obj }) => {
        const fromDate = date;
        const untilDate = obj.get("publishUntilDate");
        if (fromDate && untilDate) {
          if (fromDate > untilDate) {
            return {
              message: "Start date should be before end date",
              severity: "error",
            };
          }
        }
        return null;
      },
    ],
    [
      "publishFromDate",
      (date, { obj }) => {
        const maxDifference = 2;
        const fromDate = date;
        const untilDate = obj.get("publishUntilDate");
        const maxDate = moment(date).add(maxDifference, "years").add(1, "day");
        if (fromDate && untilDate) {
          if (moment(untilDate) > maxDate) {
            return {
              message: `Difference between end and start date of event should be smaller then ${maxDifference} years`,
              severity: "warning",
            };
          }
        }
        return null;
      },
    ],
    [
      "publishFromDate",
      (date) => {
        if (!date) {
          return {
            message: "An event object must have a publish from date specified",
            severity: "error",
          };
        }
        return null;
      },
    ],
    [
      "publishUntilDate",
      (date) => {
        if (!date) {
          return {
            message: "An event object must have a publish until date specified",
            severity: "error",
          };
        }
        return null;
      },
    ],
    [
      (obj) => {
        const hasSchema = obj
          .widgets()
          .some((w) => w.objClass() === "SchemaWidget");
        if (!hasSchema) {
          return {
            message:
              "No SchemaWidget added to this page. Please add a SchemaWidget to provide structured data for this page.",
            severity: "warning",
          };
        }
        return null;
      },
    ],
  ],
});
